import React from 'react';

interface EmptyStateProps {
  illustration: string
  illustrationAlt: string
  title: string
  description?: string
  action?: React.ReactNode
  size?: 'sm' | 'md'
}

const EmptyState: React.FC<EmptyStateProps> = ({illustration, illustrationAlt, title, description, action, size = 'md'}) => {
  const imgHeight = size === 'sm' ? 150 : 200

  return (
    <div className="d-flex flex-column flex-center text-center py-5">
      <img src={illustration} alt={illustrationAlt} className="mw-100" style={{maxHeight: `${imgHeight}px`}} />
      <h3 className="text-dark mt-4 mb-1">{title}</h3>
      {description && <div className="text-muted fw-bold">{description}</div>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  )
}

export default EmptyState;
